/**
 * Handles s output message type.
 */
export enum HsOutputMessageType {
  RendererStatistics = 'RendererStatistics',
  Error = 'Error',
  Raycast = 'Raycast',
  CameraTransform = 'CameraTransform',
  CameraFocusAtComplete = 'CameraFocusAtComplete',
  CameraLookAtComplete = 'CameraLookAtComplete',
  CameraTransitionToTargetPointAndRotateComplete = 'CameraTransitionToTargetPointAndRotateComplete',
}
